import { ChangeEvent, forwardRef, useState } from "react";
import IconWithTooltip from "../icon-with-tooltip/IconWithTooltip";
import Svg from "../svg/Svg";

interface Props {
  disabled?: boolean;
  mainClass?: string;
  maxLength?: number;
  pattern?: string;
  patternValidationText?: string;
  placeholder?: string;
  required?: boolean;
  requiredValidationText?: string;
  tooltip?: string;
  value?: string;
  isValid?: boolean;
  errors?: string[];
  onChange?: (value: string | undefined) => any;
  onClick?: () => any;
}

const TextBox = forwardRef<HTMLInputElement, Props>(
  ({ disabled, mainClass, maxLength, pattern, placeholder, required, tooltip, value, isValid, errors, onChange, ...props }: Props, ref) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const postcode = event.target.value.toUpperCase();
      if (onChange) {
        onChange(postcode);
      }
    };

    const inputClasses: string[] = ["fm-m-postcode-box__input", "tfm"];
    if (tooltip) {
      inputClasses.push("fm-m-postcode-box__input--has-tooltip");
    }
    if ((!!value && !isValid) || (required && !value)) {
      inputClasses.push("fm-m-postcode-box__input--has-error");
    }

    return (
      <div className={"fm-m-postcode-box tfm" + (mainClass ? " " + mainClass : "")}>
        <div className="fm-m-postcode-box__content">
          <input
            className={inputClasses.join(" ")}
            type="text"
            maxLength={maxLength}
            value={value}
            onChange={handleChange}
            onClick={props.onClick}
            placeholder={placeholder}
            disabled={disabled}
            ref={ref}
          />

          {((!!value && !isValid) || (required && !value)) && (
            <Svg mainClass="fm-m-postcode-box__error-indicator" iconPath="#warning" viewBoxWidth={7} viewBoxHeight={7} width={26} height={26} />
          )}
          {tooltip && <IconWithTooltip mainClass="fm-m-postcode-box__tooltip" text={tooltip} />}
        </div>
        {!!value && !!errors?.length && (
          <div className="fm-m-postcode-box__errors">
            {errors.map((error, index) => (
              <div key={index} className="fm-m-postcode-box__error">
                {error}
              </div>
            ))}
          </div>
        )}
        {required && !value && !!errors?.length && (
          <div className="fm-m-postcode-box__errors">
            <div className="fm-m-postcode-box__error">{errors[0]}</div>
          </div>
        )}
      </div>
    );
  }
);

export default TextBox;
